import * as classnames from "classnames";
import { isEqual } from "lodash";
import * as React from "react";

import {
  Modal,
  Select,
  FormGroup,
  Form,
  SelectItem,
  Icon,
  Msg,
} from "../../../../shared/components";
import { ProgrammingLanguage } from "../../../../shared/services/enums";
import { SupportedProgrammingLanguagesLink } from "../partials/SupportedProgrammingLanguagesLink";

/**
 * Prop interface
 */
export interface SwitchLanguageProps {
  isOpen: boolean;
  resultId: number;
  programmingLanguage?: ProgrammingLanguage;
  programmingLanguages: ProgrammingLanguage[];
  switchLanguage: (payload: {}, params: {}) => void;
  onSwitch?: () => void;
  onCancel?: () => void;
}

/**
 * State interface
 */
export interface SwitchLanguageState {
  formValid: boolean;
  formValues: {};
}

/**
 * Page component
 */
class SwitchLanguage extends React.Component<
  SwitchLanguageProps,
  SwitchLanguageState
> {
  constructor(props: SwitchLanguageProps) {
    super(props);

    this.state = {
      formValid: false,
      formValues: {},
    };
  }

  public shouldComponentUpdate(
    nextProps: SwitchLanguageProps,
    nextState: SwitchLanguageState,
  ) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  }

  public render() {
    const rootStyle = classnames("code-switch-language");

    const { isOpen, onCancel, programmingLanguages, programmingLanguage } =
      this.props;

    const { formValid } = this.state;

    const options = programmingLanguages.map((item) => {
      return {
        label: ProgrammingLanguage.toString(item),
        value: item,
      } as SelectItem;
    });

    return (
      <Modal
        className={rootStyle}
        title={<Msg id={"switch-language.title"} />}
        isOpen={isOpen}
        onClose={onCancel}
        onClickCancel={onCancel}
        onClickOk={this.onSwitchLanguage}
        disableOk={!formValid}
        okButtonLabel={<Msg id={"button.switchLanguage"} />}
        okButtonAriaLabel="Switch Language"
        ariaLabel="Switch Language"
      >
        <Form
          validation={{
            programmingLanguage: ["string", "required"],
          }}
          initialValues={{
            programmingLanguage: String(programmingLanguage),
          }}
          onFormChange={this.onFormChange}
          clear={!isOpen}
        >
          <div className="code-switch-language__body">
            <div className="code-switch-language__item">
              <Icon
                type="exclamation-triangle"
                iconClassName="fa-3x"
                size="large"
              />
            </div>
            <div className="code-switch-language__item">
              <p>
                <Msg id={"switch-language.text1"} />
              </p>
              <p>
                <Msg id={"switch-language.text2"} />
              </p>
            </div>
          </div>
          <SupportedProgrammingLanguagesLink />
          <FormGroup>
            <Select name="programmingLanguage" options={options} />
          </FormGroup>
        </Form>
      </Modal>
    );
  }

  private onSwitchLanguage = () => {
    const { switchLanguage, onSwitch } = this.props;
    switchLanguage(this.state.formValues, this.props.resultId);
    if (typeof onSwitch === "function") {
      onSwitch();
    }
  };

  private onFormChange = (
    _formValid: boolean,
    formValues: { programmingLanguage: number },
  ) => {
    this.setState({
      formValid: !(
        this.props.programmingLanguage ===
        Number(formValues.programmingLanguage)
      ),
      formValues,
    });
  };
}

export default SwitchLanguage;
